module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-onigiri-e161b98d8316de6d70de669b886edc87.png";